import { getPriceProperty, getSortedMulticurrencyProperties } from 'commerce-products-lib/utils/currency';
import { PRODUCT_BY_ID_ALL_PROPERTIES_QUERY, PRODUCT_DEPENDENCIES_QUERY } from './graphql/queries';
import { parseProductData, parseProductProperties } from 'commerce-products-api/graphql/queryParser';
// TODO move this function to a common library -- https://git.hubteam.com/HubSpot/commerce-products/issues/784
const queryProductData = async (graphqlClient, objectId) => {
  const {
    data,
    loading,
    error
  } = await graphqlClient.query({
    query: PRODUCT_BY_ID_ALL_PROPERTIES_QUERY,
    variables: {
      id: objectId
    }
  });
  if (data == null) {
    return {
      data,
      loading,
      error
    };
  }
  const product = parseProductData(data);
  return {
    product,
    loading,
    error
  };
};

// TODO move this function to a common library -- https://git.hubteam.com/HubSpot/commerce-products/issues/784
const getCurrencyProperties = (properties, defaultCurrencyCode, isMulticurrencyActive) => {
  if (!defaultCurrencyCode) {
    return [];
  }
  if (!isMulticurrencyActive) {
    const priceProperty = getPriceProperty(properties);
    return priceProperty ? [priceProperty] : [];
  }
  return getSortedMulticurrencyProperties(properties, defaultCurrencyCode);
};

// TODO move this function to a common library -- https://git.hubteam.com/HubSpot/commerce-products/issues/784
const queryProductDependencies = async graphqlClient => {
  var _data$currency, _data$currency2;
  const {
    data,
    loading,
    error
  } = await graphqlClient.query({
    query: PRODUCT_DEPENDENCIES_QUERY
  });
  if (data == null) {
    return {
      data,
      loading,
      error
    };
  }
  const defaultCurrencyCode = data === null || data === void 0 || (_data$currency = data.currency) === null || _data$currency === void 0 || (_data$currency = _data$currency.homeCurrency) === null || _data$currency === void 0 ? void 0 : _data$currency.currencyCode;
  const isMulticurrencyActive = data === null || data === void 0 || (_data$currency2 = data.currency) === null || _data$currency2 === void 0 ? void 0 : _data$currency2.isMulticurrencyActive;
  const properties = parseProductProperties(data.productProperties);
  const currencyProperties = getCurrencyProperties(properties, defaultCurrencyCode, isMulticurrencyActive);
  return {
    properties,
    currencyProperties,
    defaultCurrencyCode,
    isMulticurrencyActive,
    loading,
    error
  };
};

// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = async ({
  graphqlClient,
  dfcClient: __dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId: __objectTypeId
  }
}) => {
  if (objectId == null) {
    throw new Error('Bundle not found: objectId is null');
  }
  const [{
    product: bundle,
    error: productError
  }, {
    properties,
    currencyProperties,
    error: dependenciesError
  }] = await Promise.all([queryProductData(graphqlClient, objectId), queryProductDependencies(graphqlClient)]);
  if (productError) {
    throw new Error('Error fetching product data', {
      cause: productError
    });
  }
  if (dependenciesError) {
    throw new Error('Error fetching product dependencies', {
      cause: dependenciesError
    });
  }
  if (bundle == null || properties == null || currencyProperties == null) {
    throw new Error('Unexpected product bundle loading state'); // ApolloClient.query should always either resolve or error
  }
  return {
    bundle,
    properties
  };
};